import React, { useState } from 'react';
import { Button } from './ui/button';
import { Edit, Eye, LogOut } from 'lucide-react';
import { useEditMode } from '../contexts/EditModeContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import axios from 'axios';
import { useToast } from '../hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const EditModeToggle = () => {
  const { isEditMode, toggleEditMode, isAdmin, disableAdminMode } = useEditMode();
  const { toast } = useToast();

  if (!isAdmin) return null;

  const handleLogout = () => {
    disableAdminMode();
    toast({
      title: "Logout effettuato",
      description: "Sei uscito dalla modalità admin",
    });
  };

  return (
    <div className="edit-mode-toggle">
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <Button 
          onClick={toggleEditMode}
          className={isEditMode ? 'edit-mode-active' : 'edit-mode-inactive'}
          size="lg"
        >
          {isEditMode ? (
            <>
              <Eye className="w-5 h-5 mr-2" />
              Modalità Visualizzazione
            </>
          ) : (
            <>
              <Edit className="w-5 h-5 mr-2" />
              Modalità Modifica
            </>
          )}
        </Button>
        
        <Button 
          onClick={handleLogout}
          variant="outline"
          size="lg"
        >
          <LogOut className="w-5 h-5 mr-2" />
          Esci
        </Button>
      </div>

      {isEditMode && (
        <div className="edit-mode-banner">
          ✏️ <strong>MODALITÀ MODIFICA ATTIVA</strong> - Clicca su qualsiasi elemento per modificarlo
        </div>
      )}
    </div>
  );
};

export const AdminAccessButton = ({ onAdminAccess }) => {
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleAccess = async () => {
    if (!password) {
      toast({
        title: "Errore",
        description: "Inserisci la password",
        variant: "destructive"
      });
      return;
    }

    setLoading(true);
    
    try {
      const response = await axios.post(`${API}/auth/login`, { password });
      
      if (response.data.success) {
        onAdminAccess();
        setShow(false);
        setPassword('');
        toast({
          title: "Accesso riuscito!",
          description: "Benvenuto nell'area admin",
        });
      }
    } catch (error) {
      toast({
        title: "Errore",
        description: error.response?.data?.detail || "Password errata",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button 
        className="admin-access-btn"
        onClick={() => setShow(true)}
      >
        🔐 Admin
      </button>

      <Dialog open={show} onOpenChange={setShow}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Accesso Admin</DialogTitle>
          </DialogHeader>
          <div className="p-4">
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              onKeyPress={(e) => e.key === 'Enter' && handleAccess()}
              disabled={loading}
              autoFocus
            />
            <div className="flex gap-2 mt-4">
              <Button 
                variant="outline" 
                onClick={() => {
                  setShow(false);
                  setPassword('');
                }}
                disabled={loading}
              >
                Annulla
              </Button>
              <Button 
                onClick={handleAccess}
                disabled={loading}
              >
                {loading ? "Verifica..." : "Accedi"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
